import React, { useContext } from 'react';
import { Modal, Tabs, Typography, notification, Button, Table, Upload } from 'antd';
import locale from 'antd/es/locale/pt_BR';
import {
    CloudUploadOutlined,
    InboxOutlined,
    CloseOutlined
} from '@ant-design/icons';
import Loading from '../../../../components/Loading';
import useImportar from './useImportar';
import { ThemeContext } from '../../../../contexts/ThemeContext';

const { Text, Title } = Typography;

const ImportarRecibos: React.FC = () => {

    const { theme } = useContext(ThemeContext);

    const {
        loadingPage,
        setVisibleModal,
        columns,
        dadosTabelaState,
        refContagemDoFiltro,
        visibleModal,
        clickBtnSubmitUploadArquivo,
        arquivoObjeto,
        clickCancelModal,
        loading,
        activeKeyTabs,
        setActiveKeyTabs,
        dummyRequest,
        beforeUpload,
        handleChange,
        setArquivoObjeto,
    } = useImportar();

    return (
        <>
            <Loading
                loading={loadingPage}
            >
                <Title level={3}>
                    {"Importar Recibos "}
                </Title>
                <div
                    style={{
                        display: 'flex',
                        marginBottom: 15
                    }}
                >
                    <Button
                        type="primary"
                        className="botaoVerdeBaixarTodas"
                        style={{ margin: 2 }}
                        // disabled={!hasSelectedAdd}
                        onClick={() => { setVisibleModal(true) }}
                    >
                        Upload Arquivo<CloudUploadOutlined />
                    </Button>
                </div>
                <Table
                    className='marginTopTables'
                    rowKey={(record) => record.id}
                    columns={columns} dataSource={dadosTabelaState}
                    scroll={{ x: 1050 }}
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltro.current = extra.currentDataSource
                        }
                    }
                    title={(registros) => {
                        return (
                            <div
                                style={{
                                    backgroundColor:
                                        theme === "light"
                                            ? "#FAFAFA"
                                            : "#1D1D1D",
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5,
                                }}
                            >
                                <Text>
                                    {`Mostrando: ${registros.length
                                        } de ${refContagemDoFiltro.current.length === 0
                                            ? dadosTabelaState.length
                                            : refContagemDoFiltro.current.length
                                        } num total de ${dadosTabelaState.length} `}
                                </Text>
                            </div>
                        );
                    }}
                    footer={(registros) => {
                        return (
                            <div
                                style={{
                                    textAlign: "end",
                                }}
                            >
                                <Text>
                                    {`Mostrando: ${registros.length
                                        } de ${refContagemDoFiltro.current.length === 0
                                            ? dadosTabelaState.length
                                            : refContagemDoFiltro.current.length
                                        } num total de ${dadosTabelaState.length} `}
                                </Text>
                            </div>
                        );
                    }}
                    size="small"
                    pagination={{
                        locale: { items_per_page: "" },
                        showSizeChanger: true,
                        defaultPageSize: 20,
                        position: ["topRight", "bottomRight"],
                        pageSizeOptions: ["10", "20", "50", "100"],
                    }}
                    locale={locale.Table}
                />
            </Loading>
            <Modal
                title="Upload Arquivo"
                open={visibleModal}
                destroyOnClose
                onOk={() => clickBtnSubmitUploadArquivo(arquivoObjeto)}
                onCancel={() => clickCancelModal()}
                style={{
                    top: 20
                }}
                width={650}
                // className="modalDadasLimite_kaevdkfaed"
                footer={[
                    <Button
                        key="back"
                        onClick={clickCancelModal}
                        loading={loading}
                    >
                        Cancelar
                    </Button>,
                    activeKeyTabs === '1dadosDosMunicipios' ?
                        <Button
                            key="submit"
                            type="primary"
                            loading={loading}
                            onClick={() => {
                                clickBtnSubmitUploadArquivo(arquivoObjeto)
                            }}
                            disabled={!arquivoObjeto}
                        >
                            Salvar
                        </Button>
                        :
                        <></>
                ]}
                key="modalUploadArquivos"
            >
                <Loading
                    loading={loading}
                >
                    <Tabs
                        type="card"
                        // defaultActiveKey="1"
                        activeKey={activeKeyTabs}
                        style={{
                            marginBottom: 20,
                        }}
                        onChange={(e) => {
                            if (arquivoObjeto) {
                                notification.warning({
                                    message: 'Atenção',
                                    description:
                                        'Não é possivel trocar abas com arquivos pre carregados!',
                                });
                            } else {
                                setActiveKeyTabs(e)
                            }
                        }}
                        className='tab-municipios'
                        items={[
                            {
                                key: '1dadosDosMunicipios',
                                label:
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <Text
                                            style={{
                                                color: activeKeyTabs === '1dadosDosMunicipios' ? '#1677ff' : undefined
                                            }}
                                        >
                                            {'Recibos'}
                                        </Text>
                                        {/* <Text
                                            style={{
                                                color: activeKeyTabs === '1dadosDosMunicipios' ? '#1677ff' : undefined
                                            }}
                                        >
                                            {'(Planilha Juros)'}
                                        </Text> */}
                                    </div>,
                                children:
                                    <>
                                        <Upload.Dragger
                                            // name="file"
                                            // listType="picture-card"

                                            // className="avatar-uploader"
                                            style={{
                                                // width: 400,
                                                // height: 128
                                            }}
                                            // multiple={true}
                                            // fileList={arquivoObjeto}
                                            showUploadList={false}

                                            customRequest={dummyRequest}
                                            // action={() => {
                                            //     return new Promise((resolve, reject) => {
                                            //         reject('done');
                                            //     })
                                            // }}
                                            beforeUpload={beforeUpload}
                                            onChange={handleChange}
                                        // onPreview={() => {}}
                                        // onRemove={(file) => { return (true)}}
                                        >
                                            <p className="ant-upload-drag-icon">
                                                <InboxOutlined />
                                            </p>
                                            <p className="ant-upload-text" style={{ color: 'red' }}>Envio somente de arquivos .JSON</p>
                                            <p className="ant-upload-text">Clique ou arraste o arquivo para esta área para fazer upload</p>
                                        </Upload.Dragger>
                                        {arquivoObjeto &&
                                            <div style={{
                                                marginTop: 8,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}>
                                                <Text>
                                                    {arquivoObjeto?.file?.name}
                                                </Text>
                                                <Button
                                                    type='text'
                                                    danger
                                                    style={{ margin: 0, padding: 0 }}
                                                    icon={<CloseOutlined />}
                                                    onClick={() => {
                                                        setArquivoObjeto(null)
                                                    }}
                                                />
                                            </div>
                                        }
                                    </>
                            }
                        ]}
                    />

                </Loading>
            </Modal>
        </>
    );
}

export default ImportarRecibos;
